import React from 'react';

import Box from '@mui/material/Box';

export const LabelTransport = ({number, color, textColor}) => {
  return (
    <Box sx={{
      display: 'flex',
      padding: '.5em',
      backgroundColor: color,
      color: textColor
    }}>
      {number}
    </Box>
  );
};